"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const lodash_1 = require("lodash");
const context_1 = require("./context");
const Menu_1 = require("./Menu");
const IndicatorsContainer_1 = require("./IndicatorsContainer");
const MenuList_1 = require("./MenuList");
const reactstrap_1 = require("reactstrap");
const utils_1 = require("../../utils");
exports.OsmosysSelectBoxInner = () => {
    const { paths, options, setInput, input, onChange, value, boldLabel, label, isOpen, clearable, disabled, multiple, placeholder, showLabel, prettyResourceName, formatOptionLabel, filterOption, } = context_1.useOsmosysSelectBoxContext();
    let box = (react_1.default.createElement(react_select_1.default, { className: "osmosys-select-box", classNamePrefix: "osmosys-select-box", menuPortalTarget: document.body, isMulti: multiple, styles: {
            menuPortal: base => (Object.assign(Object.assign({}, base), { zIndex: 1055 })),
        }, placeholder: placeholder, isDisabled: disabled, isClearable: clearable, components: {
            IndicatorsContainer: IndicatorsContainer_1.IndicatorsContainer,
            Menu: Menu_1.Menu,
            MenuList: MenuList_1.MenuList,
        }, onInputChange: v => {
            setInput(v);
        }, value: value, inputValue: input, onChange: (v) => {
            onChange(multiple && !Array.isArray(v) ? [] : v);
        }, getOptionLabel: opt => {
            const labels = paths.label.split('/');
            return (lodash_1.get(opt, labels[0]) ||
                lodash_1.get(opt, labels[1]) ||
                lodash_1.get(opt, labels[2]) ||
                lodash_1.get(opt, labels[3]) ||
                lodash_1.get(opt, labels[4]) ||
                lodash_1.get(opt, paths.label));
        }, getOptionValue: opt => {
            const values = paths.value.split('/');
            return (lodash_1.get(opt, values[0]) ||
                lodash_1.get(opt, values[1]) ||
                lodash_1.get(opt, values[2]) ||
                lodash_1.get(opt, values[3]) ||
                lodash_1.get(opt, values[4]));
        }, formatOptionLabel: formatOptionLabel, filterOption: filterOption, options: options }));
    if (label || showLabel) {
        box = (react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement(reactstrap_1.Label, { className: utils_1.classnames(boldLabel && 'font-weight-bold') }, label || prettyResourceName.sentenceCase),
            box));
    }
    if (typeof isOpen === 'boolean') {
        box = react_1.default.createElement(reactstrap_1.Collapse, { isOpen: isOpen }, box);
    }
    return box;
};
//# sourceMappingURL=Inner.js.map